import { type MouseEvent } from 'react'
import { Button } from '@/components/ui/button'
import { X as CloseIcon } from 'lucide-react'

interface DraggableHeaderProps {
  title?: string
  onMouseDown: (e: MouseEvent) => void
  onClose?: () => void
  sourceFile?: string
}

export default function DraggableHeader({ title = 'Properties', onMouseDown, onClose, sourceFile }: DraggableHeaderProps) {
  return (
    <div
      className="flex items-stretch justify-between gap-2 mb-2 px-2 py-1 border-b border-neutral-800 bg-neutral-900/60 rounded-t-md select-none cursor-grab active:cursor-grabbing"
      onMouseDown={(e) => {
        // Prevent text selection/scroll hijack and start dragging
        e.preventDefault()
        onMouseDown(e)
      }}
      role="toolbar"
      aria-label="Move panel"
    >
      <div className="flex items-center gap-2">
        <div className="text-xs text-neutral-300">{title}</div>
      </div>
      <div className="flex items-stretch gap-2">
        {sourceFile && (
          <span className="text-[10px] text-neutral-300 bg-neutral-800/80 border border-neutral-700 rounded px-2 leading-none self-stretch flex items-center max-w-[50%] truncate">
            {sourceFile}
          </span>
        )}
        <Button
          variant="ghost"
          size="icon"
          aria-label="Close"
          onMouseDown={(e) => e.stopPropagation()}
          onClick={onClose}
          className="shrink-0"
        >
          <CloseIcon className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
